<div class="body">

    <div class="control">
        <button mat-icon-button class="button" (click)="close()">
            <mat-icon class="icon">close</mat-icon>
        </button>
    </div>

    <div class="content">
        <app-onlyoffice [file]="file"></app-onlyoffice>
    </div>

</div>